import React from 'react'
import { injectIntl, InjectedIntl, FormattedHTMLMessage } from 'react-intl'

import { unixTimeToCzDate } from '../../utils/dates'
import { notNullNorUndefined } from '../../utils/mix'
import messages from '../../i18n'
import { CZECH_PHONE_PREFIX } from '../../constants'

interface Props {
  [x: string]: any
  intl: InjectedIntl
}

export interface IntlInterface {
  translate: ({ id, defaultMessage }: any, values?: any) => string
  translateHTML: ({ id, defaultMessage }: any, values?: any) => string
  formatPhoneNumber: (fullPhoneNumber: number | string) => number | string
  formatCzechCurrency: (amount: any) => string
  formatCzechDate: (timestamp?: number) => string
  formatLoanDuration: (loanDurationMonths: number) => string
  intl: InjectedIntl
  [x: string]: any
}

const decorator = (ComposedComponent: any) => {
  const Intl: React.FunctionComponent<Props> = (props: Props) => {
    const localProps = {
      ...props,
    }

    localProps.translate = ({ id, defaultMessage }: any, values?: any) =>
      props.intl.formatMessage({ id, defaultMessage }, values)

    localProps.translateHTML = ({ id, defaultMessage }: any, values?: any) => (
      <FormattedHTMLMessage id={id} defaultMessage={defaultMessage} values={values} />
    )

    localProps.formatPhoneNumber = (fullPhoneNumber: number | string) => {
      if (notNullNorUndefined(fullPhoneNumber)) {
        const phoneNumberRegex = /^(\d{3})(\d{3})(\d{3})$/
        const parts = phoneNumberRegex.exec(fullPhoneNumber.toString())

        return parts
          ? [CZECH_PHONE_PREFIX, parts[1], parts[2], parts[3]].join(' ')
          : fullPhoneNumber
      }

      return fullPhoneNumber
    }

    localProps.formatCzechCurrency = (amount: any) => {
      if (notNullNorUndefined(amount)) {
        const value: any = parseFloat(amount.toString().replace(/\s+/, ''))
        return props.intl.formatNumber(value, {
          style: 'currency',
          currency: 'CZK',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })
      }

      return amount
    }

    localProps.formatCzechDate = unixTimeToCzDate

    localProps.formatLoanDuration = (loanDurationMonths: number) => {
      let term = loanDurationMonths
      if (term === null || term === undefined) {
        term = 0
      }

      const years = Math.floor(term / 12)
      const months = term % 12
      const yearsText = props.intl.formatMessage(messages.components.TermText.loanYears, { years })
      const monthsText =
        months > 0
          ? props.intl.formatMessage(messages.components.TermText.loanMonths, { months })
          : ''
      const durationText = []
      years && durationText.push(yearsText)
      years && months && durationText.push(props.intl.formatMessage(messages.common.and))
      months && durationText.push(monthsText)

      return durationText.join(' ')
    }

    return <ComposedComponent {...localProps} />
  }

  return injectIntl(Intl)
}

export default decorator
